import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileNotNoneContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return !!contextType && SharedFileRequestContextType.None !== contextType;
}
